import { h, Component } from "preact";
import pure from "utils/pure";
import SimpleVideoPlayer from "components/shared/simpleVideoPlayer/simpleVideoPlayer";
import { condClass, joinClasses } from "utils/utils";
import s from "components/shared/oneSheetVideo/oneSheetVideo.sss";

export default @pure class OneSheetVideo extends Component {
	constructor(props) {
		super(props);
		this.state.muted = true;

		this.toggleMute = this.toggleMute.bind(this);
	}

	toggleMute() {
		this.setState({
			muted: !this.state.muted,
		});
	}

	render() {
		const {
			options, // object
			playing, // boolean
		} = this.props;

		const {
			muted, // boolean
		} = this.state;

		const {
			autoplay = true, // boolean
			enableAudio, // boolean
			cover, // boolean
			loop, // boolean
			source, // string
		} = options;

		return (
			<div class={joinClasses(s.container, condClass(!!cover, s.cover))}>
				<SimpleVideoPlayer
					class={s.video}
					loop={loop}
					src={source}
					autoplay={autoplay}
					playing={playing}
					muted={muted}
				/>
				{enableAudio && (
					<div
						class={muted ? s.muteEnabled : s.muteDisabled}
						onClick={this.toggleMute}
					/>
				)}
			</div>
		);
	}
}
